import { Button } from '@/components/ui/button'

export function ErrorFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cream px-6 text-center font-sans">
      <h1 className="text-xl font-semibold text-ink">Something went wrong</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        This page hit an unexpected error. Reloading usually fixes it.
      </p>
      <Button onClick={() => window.location.reload()}>Reload page</Button>
    </div>
  )
}
